/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FeeType = {
    SeasonRegistration: 'SeasonRegistration',
    ClassRegistration: 'ClassRegistration',
    StudentRegistration: 'StudentRegistration',
    AdditionalFee: 'AdditionalFee'
} as const;
export type FeeType = typeof FeeType[keyof typeof FeeType];


export function instanceOfFeeType(value: any): boolean {
    for (const key in FeeType) {
        if (Object.prototype.hasOwnProperty.call(FeeType, key)) {
            if (FeeType[key as keyof typeof FeeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FeeTypeFromJSON(json: any): FeeType {
    return FeeTypeFromJSONTyped(json, false);
}

export function FeeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeeType {
    return json as FeeType;
}

export function FeeTypeToJSON(value?: FeeType | null): any {
    return value as any;
}

export function FeeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FeeType {
    return value as FeeType;
}

